"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var ReleaseItemRepricingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleaseItemRepricingConverter, _DataObjectConverter_);

  function ReleaseItemRepricingConverter() {
    _classCallCheck(this, ReleaseItemRepricingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemRepricingConverter).apply(this, arguments));
  }

  return ReleaseItemRepricingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleaseItemRepricingConverter = ReleaseItemRepricingConverter;